import { htmlDeMarkdown } from "@noesis/shared";
import { ConteudoRico } from "../caderno/ConteudoRico.js";

/**
 * A explicação do item, renderizada — **um lugar só**.
 *
 * A explicação continua sendo **Markdown**: quem virou HTML foi o caderno
 * (RN-39), e o conteúdo importado não. Só que ninguém a renderizava: o
 * diagnóstico imprimia a string crua, com `**dependência parcial**` aparecendo
 * com asteriscos na tela, e a execução apenas quebrava em parágrafos — os
 * asteriscos ficavam nos dois.
 *
 * A conversão reaproveita o que já existe e não abre caminho de injeção:
 * `htmlDeMarkdown` produz o HTML, e `ConteudoRico` o lê com `lerHtml`, que
 * devolve **árvore tipada** e monta elementos React. Nada de `innerHTML`, e o
 * saneamento da RN-41 continua rodando na leitura.
 */
export function ExplicacaoDoItem({ markdown }: { markdown: string }) {
  return <ConteudoRico html={htmlDeMarkdown(markdown)} />;
}
